import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "@/utils/classes"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        outline_primary:
          "border-transparent bg-primary-foreground text-primary hover:bg-primary-foreground/80",
        outline_foreground: "border-transparent bg-foreground text-background",
        outline_blue:
          "border-transparent bg-[#002BFF]/10 text-[#002BFF] dark:bg-[#002BFF] dark:text-white",
        success_light:
          "border-transparent bg-green-100 text-green-700 hover:bg-green-100/80",
        warning_light:
          "border-transparent bg-amber-100/50 text-amber-500 hover:bg-yellow-100/80 dark:bg-amber-50 dark:text-amber-500 dark:hover:bg-amber-50/90",
        info_light:
          "border-transparent bg-sky-100/80 text-sky-500 hover:bg-sky-100/80 dark:bg-sky-50 dark:text-sky-500 dark:hover:bg-sky-50/90",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
